import '../App.css';
import React, {useEffect}  from 'react';
import { Outlet } from "react-router-dom";
import { FaBluesky } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { BiWorld } from "react-icons/bi";
import { Link } from "react-router-dom";
import { LoginMetamask } from './LoginMetamask';
import { useWallet } from './SignedWalletProvider'; // Adjust the import path
import DeepOrbFooter from './DeepOrbFooter';


const deeporbUrl = new URL('../assets/logo64.png', import.meta.url).href;

export const HeaderBar = ({config}) => {
  const { jwtToken } = useWallet();

  return (
    <header>
      <nav className="bg-black text-white px-4 py-3">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Site Title */}
          <div className="flex items-center gap-2 mb-2 md:mb-0 min-w-[240px]">
            <Link to="/" className="flex items-center gap-2 no-underline hover:no-underline text-white">
              <img src={deeporbUrl} alt="Deeporb Logo" className="w-12 h-12" />
              <span className="text-2xl font-semibold">DeepOrb Labs</span>
            </Link>
          </div>

          {/* Site Navigation */}
          <div className='flex flex-row w-full bg-slate-700 justify-center md:justify-end md:bg-transparent p-2 rounded-lg md:p-0 md:mr-4'>
            {/* <ul className="flex items-center gap-4 md:gap-6 text-center md:items-end">
              <li>
                <Link
                  to="/plans"
                  className="hover:text-gray-400 underline text-white"
                >
                  Plans
                </Link>
              </li>
              <li>
                <Link
                  to="/metrics"
                  className="hover:text-gray-400 underline text-white"
                >
                  Metrics
                </Link>
              </li>            
              <li>
                  <Link to={config.docsUrl} className="hover:text-gray-400 underline text-white" target='_blank'>Docs</Link>
              </li>


            </ul> */}
          </div>
          {/* Wallet/Login */}
          {/* <div className="flex items-center mt-2 md:mt-0">
            <LoginMetamask />
          </div> */}
        </div>
      </nav>
    </header>
  );
}

export const FooterBar = ({config}) => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Copyright Section */}
      <DeepOrbFooter config={config} />
    </footer>
  );
}


export const PageLayout = ({ children, config }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <HeaderBar config={config} />
      {/* Main Content (Flexible Space) */}
      <main className="flex-1 page-children">
        <Outlet />
      </main>
      {/* Sticky Footer */}
      <footer className="bg-gray-900 text-white text-center py-4">
        <FooterBar config={config} />
      </footer>
    </div>
  );
}